import styled from 'styled-components'

type AlertColor = 'danger' | 'success'

export const Alert = styled.div<{ type?: AlertColor }>`
  text-align: left;
  margin-top: 12px;
  padding: 15px 20px;
  background: ${({ type }) => type === 'success' ? 'green' : '#F8373E'};
  color: white
  border-radius: 5px;
`



// WEBPACK FOOTER //
// ./src/atoms/Alert.tsx